import ConnectedAccountsPage from './Page'
export default ConnectedAccountsPage
